module.exports = __webpack_public_path__ + "img/image_02.3961ed05.png";